function getObjectWithoutSensitiveData (obj, depth = 3) {
  return Object.keys(obj)
    .reduce(function (objWithoutSensitiveData, key) {
      // If it's an object, go deeply and see if they contain any sensitive data
      const value = obj[key]

      if (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        depth > 0
      ) {
        objWithoutSensitiveData[key] = (
          getObjectWithoutSensitiveData(value, depth - 1)
        )
        return objWithoutSensitiveData
      }

      // If it's an array, check each element and see if they contain any sensitive data
      if (value && Array.isArray(value) && depth > 0) {
        objWithoutSensitiveData[key] = value.map(function (val) {
          if (val && typeof val === 'object' && !Array.isArray(val)) {
            return getObjectWithoutSensitiveData(val, depth - 1)
          } // TODO nested arrays
          return val
        })
        return objWithoutSensitiveData
      }

      // Check if the key is contain potential sensitive data
      if (!/secret|password|pw/gi.test(key)) {
        objWithoutSensitiveData[key] = value
      } else {
        console.warn(`object with keys: ${Object.keys(obj)} has potential sensitive data `)
      }
      return objWithoutSensitiveData
    }, {})
}

function stringifyObjectUtil (value) {
  try {
    if (!value) {
      return ''
    }
    if (value instanceof Error) {
      return JSON.stringify(value, Object.getOwnPropertyNames(value))
    }
    if (Array.isArray(value)) {
      return JSON.stringify(value)
    }
    if (
      typeof value === 'object' &&
      value.constructor === Object
    ) {
      const valueWithoutSensitiveData = getObjectWithoutSensitiveData(value)
      return JSON.stringify(valueWithoutSensitiveData)
    }
    return value.toString()
  } catch (error) {
    console.error('an error occurred trying to stringify: ', value)
    return ''
  }
}

const LEVEL_TO_LOG_LEVEL = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3,
  verbose: 4
}
let config = {
  level: 'debug'
}

function initLogger (options = {}) {
  config = {
    ...config,
    ...options
  }
}

function createNowDateStr () {
  const date = new Date()
  const dateStr = date.getDate().toString()
  const month = date.getMonth()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  const milliseconds = date.getMilliseconds()
  return (
    date.getFullYear().toString() + '-' + (
      (month + 1).toString().length === 2
        ? (month + 1).toString()
        : '0' + (month + 1).toString()
    ) + '-' + (
      dateStr.length === 2
        ? dateStr
        : '0' + dateStr
    ) + ' ' + (
      hours.toString().length === 2 ? hours.toString() : '0' + hours.toString()
    ) + ':' + (
      (parseInt(minutes / 5) * 5).toString().length === 2
        ? (parseInt(minutes / 5) * 5).toString()
        : '0' + (parseInt(minutes / 5) * 5).toString()
    ) + ':' + (
      seconds.toString().length === 2
        ? seconds
        : `0${seconds}`
    ) + `:${milliseconds}`
  )
}

/**
 * Creates a wrapper that will interpolate `%o` to the given object argument.
 * @private
 * @example
 * @param {Object} params
 *        {Array} params.argumentsArr
 *        {string} params.level
 *        {string} params.label
 *        {Object} [params.logger=console]
 * @returns {Object|undefined}
 */
function createFormattedLogger (params) {
  const {
    argumentsArr,
    label,
    level,
    logger = console
  } = params
  if (LEVEL_TO_LOG_LEVEL[level] > LEVEL_TO_LOG_LEVEL[config.level]) {
    return
  }
  const loggerLevelFn = logger[level]
  const argumentsCount = argumentsArr.length
  let str = ''

  for (let index = 0; index < argumentsCount; index++) {
    const argument = argumentsArr[index]

    if (index > 0) {
      str += ' '
    }

    if (typeof argument !== 'string') {
      str += stringifyObjectUtil(argument)
      continue
    }

    let interpolateArgumentIndex = index + 1
    const argumentStr = argument.split('%o').map(token => {
      const interpolatedValue = argumentsArr[interpolateArgumentIndex]

      if (interpolatedValue) {
        const dataStr = stringifyObjectUtil(interpolatedValue)
        interpolateArgumentIndex += 1
        index += 1
        return token + dataStr
      }

      return token
    }).join('')
    str += argumentStr
  }
  return loggerLevelFn(`${createNowDateStr()} [${label}]: ${str}`)
}

function createLogger (params) {
  const {
    label
  } = params

  function createLevelLogger (level) {
    return function () {
      createFormattedLogger({
        argumentsArr: [...arguments],
        label,
        level
      })
    }
  }

  return {
    log: createLevelLogger('log'),
    debug: createLevelLogger('debug'),
    info: createLevelLogger('info'),
    warn: createLevelLogger('warn'),
    error: createLevelLogger('error')
  }
}

module.exports = {
  createLogger,
  initLogger,
  stringifyObjectUtil
}
